import { createConsumer } from '@rails/actioncable';
import { authToken } from '@lib/session';

let cableInstance = null;
let cableToken: string | null = null;
let reconnectTimer = null;

export const createCable = () => {
  const token = authToken();

  // The URL bakes in whichever token was current when the consumer was built.
  // Returning the cached instance unconditionally meant that after signing out
  // and back in — or after any token change — the socket kept presenting the
  // OLD credential and was rejected forever, while HTTP requests carried the
  // new one. The dashboard then looked signed in but its vitals never updated,
  // which for a monitoring product is the worst kind of failure: it shows
  // plausible, frozen numbers rather than an error.
  if (cableInstance && cableToken === token) {
    return cableInstance;
  }

  if (cableInstance) {
    resetCable();
  }

  const consumer = createConsumer(
    `${process.env.REACT_APP_API_WS_URL}?auth=${encodeURIComponent(token || '')}`,
  );

  cableInstance = consumer;
  cableToken = token;

  return consumer;
};

export const resetCable = () => {
  if (cableInstance) {
    cableInstance.disconnect();
    cableInstance = null;
    cableToken = null;
  }
  if (reconnectTimer) {
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
  }
};

export default createCable;
